import axios from "axios";
import store from "../store";
import router from "../router";

let instance = axios.create({
    baseURL: process.env.VUE_APP_BASE_API_URL,
    params: {cache: "off"},
    transformRequest: (data, headers) => {
        headers["Authorization"] = `${store.state.accessToken}`;
        if (headers["Content-Type"]) {
            return data
        }
        headers["Content-Type"] = "application/json";
        return JSON.stringify(data);
    },
});

instance.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response.status !== 401) {
            return Promise.reject(error);
        }
        // if (!store.state.refreshToken) {
        store.commit("signOut");
        router.push({name: 'Auth'});
        return Promise.reject(error);
        // }
        //     return axios
        //         .post(
        //             `${process.env.VUE_APP_BASE_API_URL}api/v1/refresh-token`,
        //             {
        //                 refresh_token: store.state.refreshToken
        //             })
        //         .then(({data}) => {
        //             store.commit("authenticate", data);
        //             return instance(error.response.config);
        //         })
        //         .catch(() => {
        //             store.commit("signOut");
        //             router.push({name: "Auth"});
        //             return Promise.reject(error);
        //         });
    }
);

export default instance;
